export default __webpack_public_path__ + "static/media/Parallax-HUD-3D (Environmental Scan).14967721.jpg";